import { createNavigation } from 'next-intl/navigation';
import { type LocalePrefixMode } from 'next-intl/routing';

import { DEFAULT_LOCALE } from '@module/mdrt-org/shared/i18n/locales';

import { localePrefixes } from './locale-prefixes';

export const localePrefixMode = 'as-needed' as const satisfies LocalePrefixMode;

const NavigationHelpers = createNavigation({
  defaultLocale: DEFAULT_LOCALE,
  localePrefix: {
    mode: localePrefixMode,
    prefixes: localePrefixes,
  },
});

export const { Link: LinkBase, redirect, usePathname, useRouter } = NavigationHelpers;
